<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-3">
                    <label><label style="color: red; height: 2px;" >*</label>
                        از تاریخ</label>
                    <Datepicker simple auto-submit id="from-date" locale="fa" input-format="YYYY-MM-DD" v-model="fromDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
                <div class="col-md-3">
                    <label><label style="color: red; height: 2px;" >*</label>
                        تا تاریخ</label>
                    <Datepicker simple auto-submit id="to-date" locale="fa" input-format="YYYY-MM-DD" v-model="toDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>دامنه</label>
                        <Vselect v-model="domainId" :reduce="item => item.value" label="title" :options="domains">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>دامنه داده ای</label>
                        <Vselect v-model="domainDataId" :reduce="item => item.value" label="title" :options="domainData">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>
                </div>
            </div>
            <div class="row" style="display: flex; justify-content: end;">
                <div class="col-md-3" style="margin-top: 29px">
                    <button class="btn btn-primary btn-block" @click="submit" :disabled="!fromDate || !toDate">
                        <i class="si si-magnifier"></i>
                        جستجو
                    </button>
                </div>
            </div>
            <div class="alert alert-info mt-4 mb-0" v-if="!rows.length && isSearched">
                <p class="mb-0">اطلاعاتی یافت نشد</p>
            </div>
            <hr v-if="rows.length">
            <table class="table table-hover table-bordered mb-0" v-if="rows.length">
                <thead>
                    <tr>
                        <th>نوع مشتری</th>
                        <th>نام و نام خانوادگی</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row,index) in rows" :key="index">
                        <td>{{ row.domain_title }}</td>
                        <td>{{ row.doamain_data_title }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="row mt-3" v-if="pages.length > 1" style="overflow-x: hidden;">
                <div class="col-12" style="overflow-x: auto;">
                    <ul class="pagination pagination-circled">
                        <li class="page-item" v-if="currentPage > 1">
                            <a class="page-link" href="#" v-on:click="currentPage--"><i class="icon ion-ios-arrow-forward"></i></a>
                        </li>
                        <li :class="currentPage == page ? 'page-item active' : 'page-item'" v-for="page in pages" :key="page">
                            <a class="page-link" href="#" v-on:click="currentPage = page">{{ page }}</a>
                        </li>
                        <li class="page-item" v-if="pages.length != currentPage">
                            <a class="page-link" href="#" v-on:click="currentPage++"><i class="icon ion-ios-arrow-back"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
            <p v-if="rows.length" class="mt-4 mb-0">تعداد کل : {{ count }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CustomerReport',
    data(){
        return {
            showLoading: true,
            isSearched: false,
            rows: [],
            fromDate: '',
            toDate: '',
            currentPage: 1,
            pages: [1],
            domains: [],
            domainId: '',
            domainDataId: '',
            allDomainData: [],
            domainData: [],
            perPage: 100,
            count: 0
        }
    },
    watch: {
        currentPage(value){
            this.currentPage = value;
            this.getData();
        },
        domainId(value){
            let domainData = [];
            this.allDomainData.map(item => {
                if(item.domainId == value)
                    domainData.push({
                        title: item.fullName || '-',
                        value: item.domainDataId
                    });
            })
            this.domainData = domainData;
        }
    },
    methods: {
        baseData(){
            this.$api.post('User/GetDomain',{}).then(({data}) => {
                if(data.status){
                    let domains = [];
                    data.result.map(item => {
                        if(item.title == 'شعبه')
                            domains.push({
                                title: item.title,
                                value: item.domainId
                            });
                    })
                    this.domains = domains;
                }
            });
            this.$api.post('User/GetDomainData',{}).then(({data}) => {
                if(data.status){
                    this.allDomainData = data.result;
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        getData(){
            this.showLoading = true;
            const postedData = {
                p_fromdate: this.fromDate.replace(/\//g,''),
                p_todate: this.toDate.replace(/\//g,''),
                p_offset: this.currentPage,
                p_limit: this.perPage,
                p_domaindate_id: this.domainDataId,
                p_domain_id: this.domainId
            };
            this.$api.post('Branches/Report/Stock',postedData).then(({data}) => {
                if(data.status && data.result && data.result.p_result){
                    this.rows = data.result.p_result;
                    this.count = data.result.v_count[0].cnt_total;
                    let calcPages = Math.ceil((this.count) / this.perPage);
                    calcPages = calcPages > 1 ? calcPages : 1
                    let pagesArray = [];
                    for(let i = 1;i <= calcPages;i++)
                        pagesArray.push(i);
                    this.pages = pagesArray;
                }
            }).finally(() => {
                this.isSearched = true;
                this.showLoading = false;
            });
        },
        submit(){
            this.getData();
        }
    },
    created(){
        this.baseData();
    }
}
</script>